import React from 'react';
import '../styles/AnimatedBackground.css';

const AnimatedBackground: React.FC = () => {
  return (
    <div className="animated-background">
      <div className="cube-container">
        {[...Array(10)].map((_, index) => (
          <div key={index} className="cube">
            <div className="cube-face front"></div>
            <div className="cube-face back"></div>
            <div className="cube-face right"></div>
            <div className="cube-face left"></div>
            <div className="cube-face top"></div>
            <div className="cube-face bottom"></div>
          </div>
        ))}
      </div>
      <div className="floating-circles">
        {[...Array(15)].map((_, index) => (
          <div key={index} className="circle"></div>
        ))}
      </div>
      <div className="gradient-overlay"></div>
    </div>
  );
};

export default AnimatedBackground;